/** Sepolia FBH, plus the two mainnet full-body contracts stored on hape rows. */
const FULL_BODY_CONTRACTS = new Set([
	"0x1e4c3e713584264db5361c489d58cc084ce19794",
	"0x3b09cc64797ef04c8878471038a5c432da57325c",
	"0xdc758b92c7311280aeeb48096a3bf4d1c1f936d4",
])

export function isFullBodyContract(address?: string | null): boolean {
	return FULL_BODY_CONTRACTS.has((address || "").trim().toLowerCase())
}

export function isFullBodyHape(hape?: {
	is_fbh?: number | string
	contract_address?: string
} | null): boolean {
	if (!hape) return false
	if (Number(hape.is_fbh) === 1) return true
	return isFullBodyContract(hape.contract_address)
}


/** Production equip contracts on Ethereum mainnet (chain id 1). */
export const MAINNET_EQUIP_CONTRACTS = {
	HapeEquip_Contract_address: "0xf243BD5fa3788484F36bE751cE869FB9d5866b92",
	HapeAccessory_Contract_address: "0xF147FEfEE8436622E6d6a45E38c60fA6164cBDd3",
	FBH_Contract_address: "0x3B09cc64797ef04C8878471038A5C432da57325C",
} as const

/**
 * Sepolia copies of the equip contracts.
 * Set NEXT_PUBLIC_EQUIP_NETWORK=sepolia to select these. A specific
 * NEXT_PUBLIC_HAPE_EQUIP_CONTRACT / NEXT_PUBLIC_HAPE_ACCESSORY_CONTRACT /
 * NEXT_PUBLIC_FBH_CONTRACT value still wins over either set.
 */
export const SEPOLIA_EQUIP_CONTRACTS = {
	HapeEquip_Contract_address: "0x46fBce351037CdC4D6eB9dFB2D2e69313F02462F",
	HapeAccessory_Contract_address: "0xF9Bbc1480cDD9E25C4B64f64e1c87B3768AE28d2",
	FBH_Contract_address: "0x1e4C3e713584264dB5361C489d58CC084ce19794",
} as const

export type EquipContractAddresses = {
	HapeEquip_Contract_address: string
	HapeAccessory_Contract_address: string
	FBH_Contract_address: string
}

export type EquipContractEnv = {
	NEXT_PUBLIC_EQUIP_NETWORK?: string
	NEXT_PUBLIC_HAPE_EQUIP_CONTRACT?: string
	NEXT_PUBLIC_HAPE_ACCESSORY_CONTRACT?: string
	NEXT_PUBLIC_FBH_CONTRACT?: string
}

function trimmed(value: string | undefined): string {
	return (value || "").trim()
}

/** mainnet unless NEXT_PUBLIC_EQUIP_NETWORK is sepolia (or chain id 11155111). */
export function equipNetwork(env: EquipContractEnv): "mainnet" | "sepolia" {
	const raw = trimmed(env.NEXT_PUBLIC_EQUIP_NETWORK).toLowerCase()
	if (raw === "sepolia" || raw === "11155111") return "sepolia"
	return "mainnet"
}

function pickAddress(override: string | undefined, fallback: string): string {
	const value = trimmed(override)
	return value || fallback
}

export function resolveEquipContracts(env: EquipContractEnv): EquipContractAddresses {
	const defaults = equipNetwork(env) === "sepolia" ? SEPOLIA_EQUIP_CONTRACTS : MAINNET_EQUIP_CONTRACTS
	return {
		HapeEquip_Contract_address: pickAddress(
			env.NEXT_PUBLIC_HAPE_EQUIP_CONTRACT,
			defaults.HapeEquip_Contract_address,
		),
		HapeAccessory_Contract_address: pickAddress(
			env.NEXT_PUBLIC_HAPE_ACCESSORY_CONTRACT,
			defaults.HapeAccessory_Contract_address,
		),
		FBH_Contract_address: pickAddress(env.NEXT_PUBLIC_FBH_CONTRACT, defaults.FBH_Contract_address),
	}
}

// Direct NEXT_PUBLIC_* reads so Next can inline them. Defaults are mainnet.
const resolvedEquipContracts = resolveEquipContracts({
	NEXT_PUBLIC_EQUIP_NETWORK: process.env.NEXT_PUBLIC_EQUIP_NETWORK,
	NEXT_PUBLIC_HAPE_EQUIP_CONTRACT: process.env.NEXT_PUBLIC_HAPE_EQUIP_CONTRACT,
	NEXT_PUBLIC_HAPE_ACCESSORY_CONTRACT: process.env.NEXT_PUBLIC_HAPE_ACCESSORY_CONTRACT,
	NEXT_PUBLIC_FBH_CONTRACT: process.env.NEXT_PUBLIC_FBH_CONTRACT,
})

export const CONTRACT_ADDRESS = {
	FBH_Contract_address: resolvedEquipContracts.FBH_Contract_address,
	HapeAccessory_Contract_address: resolvedEquipContracts.HapeAccessory_Contract_address,
	HapeEquip_Contract_address: resolvedEquipContracts.HapeEquip_Contract_address,

	HAPE_old: "0x7989d99cAdAf36896BcE62f1486Bb03A5A8483E3",
	HAPEAccessory_old: "0x7889504fc6066A7AEd61687F23BAC7684f0aF1F5",

	PaymentContract_address: "0x02fC01D8c85066be247B26a3Dec838aB7214cc73",

	BoxContract_address: "0xb04c68410f71a65b6b4e5bc30c7bb16281027f0d",
}
